var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.33319H0V26.6668H32V5.33319Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.6175C21.6769 14.6175 21.2769 14.6175 20.6154 14.6175C20.6154 17.1665 18.5489 19.2329 16 19.2329C13.4509 19.2329 11.3846 17.1665 11.3846 14.6175C10.9385 14.6175 10.4461 14.6175 10 14.6175C10 17.3632 11.8443 19.6781 14.3617 20.3911C14.0858 20.9154 14.1277 21.5755 14.5219 22.0674C15.0397 21.6524 15.5759 21.2228 16.0308 20.8583C16.4856 21.2228 17.0217 21.6524 17.5396 22.0674C17.9377 21.5706 17.9769 20.9021 17.6917 20.3752C20.1816 19.6449 22 17.3438 22 14.6175Z",
    fill: "#6DA544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3077 14.1561C12.3077 14.1561 12.3077 16.4638 14.6154 16.4638L15.077 16.9253H16.0001C16.0001 16.9253 16.4616 15.5407 17.3847 15.5407C17.3847 15.5407 17.3847 14.6176 18.3077 14.6176C19.2308 14.6176 19.6924 14.6176 19.6924 14.6176C19.6924 14.6176 19.2308 12.7715 21.5385 11.3869L20.6154 10.9253C20.6154 10.9253 17.3847 13.233 15.077 12.7714V13.6945H14.1539L13.6924 13.2329L12.3077 14.1561Z",
    fill: "#FFDA44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/CY.283a4b47.svg";
export { ForwardRef as ReactComponent };